/* eslint-disable @typescript-eslint/no-explicit-any */
import { InjectionToken } from "@angular/core";

//export const FUSE_CONFIG = new InjectionToken<any>('FUSE_APP_CONFIG');
export const FUSE_CONFIG = new InjectionToken<any>("OCTO_CONFIG");

export const APP_NAME = "Erp";

export const APP_VERSION = "1.0.0";

export const APP_MODULE_NAME = () => {
  const path = window.location.pathname;
  const segments = path.split("/").filter((segment) => segment.length > 0);
  return segments.length > 0 ? segments[0] : "home";
};
